$(() => {
  const SHORT_TEXT_CHARACTERS_LENGTH = 270;
  const longTextBlurb = $('.long_text_blurb');

  const initializeLongTextBlurb = (element) => {
    const showMoreButton = $(element).find('.show-more-button');
    const showLessButton = $(element).find('.show-less-button');
    const longTextSpan = $(element).find('.long-text');
    const fullText = longTextSpan.text();
    const truncatedText = fullText.substring(0, SHORT_TEXT_CHARACTERS_LENGTH);

    if (fullText.length > SHORT_TEXT_CHARACTERS_LENGTH) {
      longTextSpan.text(truncatedText);
    } else {
      showMoreButton.hide();
    }
    showLessButton.hide();

    showMoreButton.on('click', () => {
      longTextSpan.text(fullText);
      showMoreButton.hide();
      showLessButton.show();
    });
    showLessButton.on('click', () => {
      longTextSpan.text(truncatedText);
      showLessButton.hide();
      showMoreButton.show();
    });
  };

  longTextBlurb.each((_, element) => initializeLongTextBlurb(element));
});
